export default __webpack_public_path__ + "static/media/p15.f4736637.jpg";